// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 试玩游戏启动
// Req : open_proto.client.v1.game.LaunchGameClientReq
// Resp: open_proto.client.v1.game.LaunchGameResp
export const launchTryGame = (data) => {
  return service({
    url: '/v1/game/launchTryGame',
    method: 'post',
    data
  })
}
// 游戏启动
// Req : open_proto.client.v1.game.LaunchGameClientReq
// Resp: open_proto.client.v1.game.LaunchGameResp
export const launchGame = (data) => {
  return service({
    url: '/v1/game/launchGame',
    method: 'post',
    data
  })
}
// 获取游戏其他信息
// Req : open_proto.client.v1.game.GetGameOtherInfoReq
// Resp: open_proto.client.v1.game.GetGameOtherInfoResp
export const getGameOtherInfo = (data) => {
  return service({
    url: '/v1/game/getGameOtherInfo',
    method: 'post',
    data
  })
}
// 根据游戏组Sid获取游戏组
// Req : open_proto.client.v1.game.GetGameGroupByGameGroupSidReq
// Resp: open_proto.client.v1.game.GetGameGroupByGameGroupSidResp
export const getGameGroupBySid = (data) => {
  return service({
    url: '/v1/game/getGameGroupBySid',
    method: 'post',
    data
  })
}
// 获取游戏记录列表
// Req : open_proto.client.v1.game.ListGameRecordClientReq
// Resp: open_proto.client.v1.game.ListGameRecordClientResp
export const listGameRecordClient = (data) => {
  return service({
    url: '/v1/game/listGameRecordClient',
    method: 'post',
    data
  })
}
// 调用游戏服踢人下线
// Req : open_proto.client.v1.game.KillPlayerUserReq
// Resp: open_proto.client.v1.game.KillPlayerUserResp
export const killPlayerUser = (data) => {
  return service({
    url: '/v1/game/killOff',
    method: 'post',
    data
  })
}
// 收藏游戏
// Req : open_proto.client.v1.game.CollectReq
// Resp: open_proto.common.SuccessResp
export const collect = (data) => {
  return service({
    url: '/v1/game/collect',
    method: 'post',
    data
  })
}
// 收藏的游戏列表
// Req : open_proto.client.v1.game.CollectListReq
// Resp: open_proto.client.v1.game.CollectListResp
export const collectList = (data) => {
  return service({
    url: '/v1/game/collectList',
    method: 'post',
    data
  })
}
// 收藏的游戏列表所在厂商组
// Req : open_proto.client.v1.game.CollectBrandListReq
// Resp: open_proto.client.v1.game.CollectBrandListResp
export const collectBrandList = (data) => {
  return service({
    url: '/v1/game/collectBrandList',
    method: 'post',
    data
  })
}
// 获取JP奖励信息
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.game.GetJpRewardInfoResp
export const getJpRewardInfo = (data) => {
  return service({
    url: '/v1/game/getJpRewardInfo',
    method: 'post',
    data
  })
}
// 游戏搜索
// Req : open_proto.client.v1.game.GameSearchReq
// Resp: open_proto.client.v1.game.GameSearchResp
export const gameSearch = (data) => {
  return service({
    url: '/v1/game/gameSearch',
    method: 'post',
    data
  })
}
// 获取投注记录
// Req : open_proto.client.v1.game.GetBetHistoryReq
// Resp: open_proto.client.v1.game.GetBetHistoryResp
export const getBetHistory = (data) => {
  return service({
    url: '/v1/game/getBetHistory',
    method: 'post',
    data
  })
}
// 品牌游戏数量
// Req : open_proto.client.v1.game.GetJumpBindGameCountReq
// Resp: open_proto.client.v1.game.GetJumpBindGameCountResp
export const getJumpBindGameCount = (data) => {
  return service({
    url: '/v1/game/getJumpBindGameCount',
    method: 'post',
    data
  })
}
// 品牌游戏统计
// Req : open_proto.client.v1.game.GetJumpBindGameStatisticsReq
// Resp: open_proto.client.v1.game.GetJumpBindGameStatisticsResp
export const getJumpBindGameStatistics = (data) => {
  return service({
    url: '/v1/game/getJumpBindGameStatistics',
    method: 'post',
    data
  })
}
// 历史游戏
// Req : open_proto.client.v1.game.LatestListReq
// Resp: open_proto.client.v1.game.LatestListResp
export const latestList = (data) => {
  return service({
    url: '/v1/game/latestList',
    method: 'post',
    data
  })
}
// 历史游戏所在厂商组
// Req : open_proto.client.v1.game.LatestBrandListReq
// Resp: open_proto.client.v1.game.LatestBrandListResp
export const latestBrandList = (data) => {
  return service({
    url: '/v1/game/latestBrandList',
    method: 'post',
    data
  })
}
// 幸运游戏
// Req : open_proto.client.v1.game.LuckyListReq
// Resp: open_proto.client.v1.game.LuckyListResp
export const luckyList = (data) => {
  return service({
    url: '/v1/game/luckyList',
    method: 'post',
    data
  })
}
// 最近游戏列表
// Req : open_proto.client.v1.game.GetLatestGameListReq
// Resp: open_proto.client.v1.game.GetLatestGameListResp
export const getLatestGameList = (data) => {
  return service({
    url: '/v1/game/getLatestGameList',
    method: 'post',
    data
  })
}
// 
// Req : open_proto.client.v1.game.GetGameLimitReq
// Resp: open_proto.client.v1.game.GameLimit
export const getGameLimit = (data) => {
  return service({
    url: '/v1/game/getGameLimit',
    method: 'post',
    data
  })
}
// 热门新游列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.game.GetHotNewGameListResp
export const getHotNewGameList = (data) => {
  return service({
    url: '/v1/game/getHotNewGameList',
    method: 'post',
    data
  })
}
// 游戏内免费下注确认收到弹窗
// Req : open_proto.common.Undefined
// Resp: open_proto.common.Undefined
export const freeBetPopConfirm = (data) => {
  return service({
    url: '/v1/game/freeBetPopConfirm',
    method: 'post',
    data
  })
}
// 获取免费投注记录
// Req : open_proto.client.v1.game.GetFreeBetRecordReq
// Resp: open_proto.client.v1.game.GetFreeBetRecordResp
export const getFreeBetRecord = (data) => {
  return service({
    url: '/v1/game/getFreeBetRecord',
    method: 'post',
    data
  })
}
